import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const createRetailerSalesOrder = createAsyncThunk(
  "SaleOrder/InsertRetailerSalesOrder",
  async (RetailerSalesOrderData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SaleOrder/InsertRetailerSalesOrder`,
        RetailerSalesOrderData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating retailer sales order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateRetailerSalesOrder = createAsyncThunk(
  "SaleOrder/UpdateRetailerSalesOrder",
  async (RetailerSalesOrderData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SaleOrder/UpdateRetailerSalesOrder`,
        RetailerSalesOrderData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating retailer sales order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteRetailerSalesOrder = createAsyncThunk(
  "SaleOrder/DeleteRetailerSalesOrder",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SaleOrder/DeleteRetailerSalesOrder`,
        { id: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting retailer sales order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getRetailerSalesOrderByID = createAsyncThunk(
  "SaleOrder/FindByIDRetailerSalesOrder",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SaleOrder/FindByIDRetailerSalesOrder`,
        { id: ID }
      );
      // return response.data?.Data as any;
      const result = response.data?.Data as any;
      return {
        id: result?.id,
        retailerid: result?.retailerid,
        retailer_name: result?.retailer_name,
        remarks: result?.remarks,
        sr_retailer_id: result?.sr_retailer_id,
        date: result?.date ? moment(result?.date, "YYYY-MM-DD").toDate() : "",
        retailer_sales: result?.retailer_sales
          ? result?.retailer_sales?.map((retailersales: any) => {
              return {
                item_group_id: retailersales?.item_group_id
                  ? retailersales?.item_group_id
                  : null,
                item_group: retailersales?.item_group
                  ? retailersales?.item_group
                  : "",
                retailer_sales_order_list:
                  retailersales?.retailer_sales_order_list
                    ? retailersales?.retailer_sales_order_list?.map(
                        (soitem: any) => {
                          return {
                            id: soitem?.id ? +soitem?.id : null,
                            item_group_id: soitem?.item_group_id
                              ? +soitem?.item_group_id
                              : null,
                            sale_order_id: soitem?.sale_order_id
                              ? +soitem?.sale_order_id
                              : null,
                            item_id: soitem?.item_id ? +soitem?.item_id : null,
                            product_name: soitem?.product_name
                              ? soitem?.product_name
                              : "",
                            mrp: soitem?.mrp ? +soitem?.mrp : null,
                            quantity: soitem?.quantity
                              ? +soitem?.quantity
                              : null,
                            free_qty: soitem?.free_qty
                              ? +soitem?.free_qty
                              : null,
                            // [`qty_${mainIndex}_${subIndex}`]: soitem?.quantity
                            //   ? +soitem?.quantity
                            //   : null,
                            unit_id: soitem?.unit_id ? +soitem?.unit_id : null,
                            rate: soitem?.rate ? +soitem?.rate : null,
                            gst_id: soitem?.gst_id ? +soitem?.gst_id : null,
                            amount: soitem?.total_amount
                              ? +soitem?.total_amount
                              : null,
                            unit_name: soitem?.unit_name
                              ? soitem?.unit_name
                              : "",
                            gst: soitem?.gst ? +soitem?.gst : null,
                          };
                        }
                      )
                    : [],
              };
            })
          : [],
        scheme: result?.scheme
          ? result?.scheme?.split(",")?.map((scheme: any) => +scheme)
          : [],
        retailer_options: result?.retailer_options
          ? result?.retailer_options
          : [],
        total_amount: result?.total_amount,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching retailer order details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllRetailerSalesOrders = createAsyncThunk(
  "SaleOrder/FindAllRetailerSalesOrder",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SaleOrder/FindAllRetailerSalesOrder`,
        formData
      );
      const result = response.data?.Data;
      return result
        // ? result?.map((retailerso: any, index: number) => {
        //     return {
        //       ItemCount: retailerso?.ItemCount,
        //       uniqueKey: index + 1,
        //       retailer_sales_order_no: 90,
        //       id: retailerso?.id ? +retailerso?.id : null,
        //       retailerid: retailerso?.retailerid
        //         ? +retailerso?.retailerid
        //         : null,
        //       date: retailerso?.date ? retailerso?.date : "",
        //       retailer_name: retailerso?.retailer_name
        //         ? retailerso?.retailer_name
        //         : "",
        //     };
        //   })
        // : [];
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Retailer Sales Orders:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllRetailerMarginRates = createAsyncThunk(
  "ItemGroup/RetailerMarginRates",
  async (isdistributer: boolean) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ItemGroup/RetailerMarginRates`,
        {
          isdistributer: isdistributer,
        }
      );
      const result = response.data?.Data;
      return result.map((item: any) => {
        return {
          item_group_id: item?.item_group_id,
          item_group: item?.item_group,
          item_margin_rate: item?.item_margin_rate
            ? item?.item_margin_rate?.map((subitem: any) => {
                return {
                  item_id: subitem?.item_id ? +subitem?.item_id : null,
                  unit_id: subitem?.unit_id ? +subitem?.unit_id : null,
                  unit_decimal: subitem?.unit_decimal
                    ? +subitem?.unit_decimal
                    : 0,
                  unit_name: subitem?.unit_name ? subitem?.unit_name : "",
                  unit_code: subitem?.unit_code ? subitem?.unit_code : "",
                  item_group_id: subitem?.item_group_id
                    ? +subitem?.item_group_id
                    : null,
                  product_name: subitem?.product_name
                    ? subitem?.product_name
                    : "",
                  mrp: subitem?.mrp ? +subitem?.mrp : null,
                  rate: subitem?.rate ? +subitem?.rate : null,
                  retail_margin: subitem?.retail_margin
                    ? +subitem?.retail_margin
                    : null,
                  retail_rate_include_gst: subitem?.retail_rate_include_gst
                    ? +subitem?.retail_rate_include_gst
                    : null,
                  retail_sgst: subitem?.retail_sgst
                    ? +subitem?.retail_sgst
                    : null,
                  retail_cgst: subitem?.retail_cgst
                    ? +subitem?.retail_cgst
                    : null,
                  retail_rate_exclude_gst: subitem?.retail_rate_exclude_gst
                    ? +subitem?.retail_rate_exclude_gst
                    : null,
                  distributor_rate_include_gst:
                    subitem?.distributor_rate_include_gst
                      ? +subitem?.distributor_rate_include_gst
                      : null,
                  distributor_sgst: subitem?.distributor_sgst
                    ? +subitem?.distributor_sgst
                    : null,
                  distributor_cgst: subitem?.distributor_cgst
                    ? +subitem?.distributor_cgst
                    : null,
                  distributor_rate: subitem?.distributor_rate
                    ? +subitem?.distributor_rate
                    : null,
                  gst_id: subitem?.gst_id ? +subitem?.gst_id : null,
                  gst: subitem?.gst ? +subitem?.gst : null,
                };
              })
            : [],
        };
      });
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Item Margin Rates:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
